import React, { useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import GroupsIcon from "@mui/icons-material/Groups";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DiamondIcon from "@mui/icons-material/Diamond";
import StarIcon from "@mui/icons-material/Star";
export default function Dashboard() {
    const [stats] = useState({
        totalProducts: 120,
        totalPlans: 120,
        totalUsers: 250,
        todayIncome: 15000,
        thisMonthIncome: 450000,
        goldPlanUsers: 80,
    });
    const cardData = [
        { title: "Total Products", value: stats.totalProducts, icon: <Inventory2Icon sx={{ fontSize: 40 }} />, color: "#4caf50" },
        { title: "Total Users", value: stats.totalUsers, icon: <GroupsIcon sx={{ fontSize: 40 }} />, color: "#ff9800" },
        { title: "Today's Income", value: `₹${stats.todayIncome.toLocaleString()}`, icon: <MonetizationOnIcon sx={{ fontSize: 40 }} />, color: "#9c27b0" },
        { title: "This Month Income", value: `₹${stats.thisMonthIncome.toLocaleString()}`, icon: <CalendarTodayIcon sx={{ fontSize: 40 }} />, color: "#00bcd4" },
        { title: "Total Orders", value: stats.totalPlans, icon: <StarIcon sx={{ fontSize: 40 }} />, color: "#2196f3" },
        { title: "Pending Orders", value: stats.goldPlanUsers, icon: <DiamondIcon sx={{ fontSize: 40 }} />, color: "#c40707" },
    ];
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Dashboard</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                {cardData.map((card, index) => (
                    <Paper key={index} elevation={1} sx={{ display: "flex", alignItems: "center", p: 3, borderRadius: 3, backgroundColor: card.color, color: "#fff", width: 300, minHeight: 140 }}>
                        <Box sx={{ mr: 3 }}>{card.icon}</Box>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>{card.title}</Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700, mt: 0.5 }}>{card.value}</Typography>
                        </Box>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
}